import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

function LiveTimer() {
  const [currentTime, setCurrentTime] = useState(dayjs().format('HH:mm') + ' IST');

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(dayjs().format('HH:mm') + ' IST');
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return <div className="time-text">{currentTime}</div>;
}

export default LiveTimer;
